<template>
    <div>
       <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch" label-width="90px">
            <el-form-item label="字典名称" prop="title">
                <el-input v-model="searchForm.title" placeholder="字典名称" style="width: 230px"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                <el-button @click="handleReset" size="small">重置</el-button>
            </el-form-item>
        </el-form>

        <div style="padding-bottom: 10px">
            <el-button  icon="el-icon-plus" type="primary" size="small" @click="handleAddDict">添加字典</el-button>
        </div>

        <el-table :data="dicList" border style="width: 100%" size="small"  v-loading="isLoading" element-loading-text="拼命加载中">
            <el-table-column type="index" prop="index" label="#" width="60" align="center"></el-table-column>
            <el-table-column prop="title" label="字典名称"></el-table-column>
            <el-table-column prop="value" label="数据值">
                <template slot-scope="{ row }">
                    <el-tag size="small">{{row.value}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="description" label="备注" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
            <el-table-column label="操作" width="180" prop="action">
                <template slot-scope="{ row, index }">
                    <el-button type="primary" size="mini" style="margin-right: 5px" @click="handleEditDict(row)">编辑</el-button>
                    <el-button type="danger" size="mini" style="margin-right: 5px" @click="handleDelDict(row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="text-align: right; padding: 10px 20px 0 0;">
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total" :page-sizes="[10, 20, 50]"  :current-page.sync="searchForm.pageNumber" :page-size="searchForm.pageSize" @current-change="handleChangePage" @size-change="handleChangePageSize"></el-pagination>
        </div>

         <!-- 添加字典 -->
        <el-dialog :title="modelForm.id ? '编辑字典' : '新增字典'" :visible.sync="isShow" width="500px">

            <el-form ref="modelForm" :model="modelForm" label-width="90px" size="small" :rules="modelFormValidate">
                <el-form-item label="字典名称" prop="title">
                    <el-input type="text" v-model="modelForm.title" clearable placeholder="请输入字典名称" style="width: 300px"/>
                </el-form-item>

                <el-form-item label="数据值" prop="value">
                    <el-input type="text" v-model="modelForm.value" clearable placeholder="请输入数据值" style="width: 300px"/>
                </el-form-item>

                <el-form-item label="备注" prop="description">
                    <el-input type="text" v-model="modelForm.description" clearable placeholder="请输入备注" style="width: 300px"/>
                </el-form-item>

                <!-- <el-form-item label="排序值" prop="sortOrder">
                    <el-input type="number" v-model="modelForm.sortOrder" clearable style="width: 120px"/>
                    <span style="margin-left:5px">值越小越靠前，支持小数</span>
                </el-form-item>

                <el-form-item label="状态" prop="status">
                    <el-switch v-model="modelForm.status" active-color="#13ce66" inactive-color="#ff4949"  :active-value="0"  :inactive-value="1"></el-switch>
                </el-form-item> -->

            </el-form>
            <div slot="footer">
                <el-button type="text" size="small" @click="isShow = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit('modelForm')">提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {
        getAllDictDataList,
        addDictData,
        editDictData,
        deleteData
    } from "./dictManage";
    export default {
        props: ["parentId"],
        data(){
            return{
                searchForm: {
                    title: "",
                    status: "",
                    pageNumber: 1,
                    pageSize: 10,
                    sort: "sortOrder",
                    order: "asc"
                },
                isLoading: false,
                dicList: [],
                total: 0,
                isShow: false,
                isChild: false,
                partentId: "",
                modelForm: {
                    title: "",
                    value: "",
                    description: "",
                },
                modelFormValidate: {
                    title: [{required: true, message: "请输入字典名称", trigger: "blur"}],
                    value: [{required: true, message: "请输入数据值", trigger: "blur"}],
                },
                submitLoading: false
            }
        },
        methods:{
            handleConfigDict(row) {
                this.partentId = row.id;
                this.isChild = true;
            },
            handleSubmit(formName) {
                this.$refs[formName].validate((valid)=>{
                    if(valid){

                        this.submitLoading = true;
                        if(this.modelForm.id) {
                            this.handleEditDataApi();
                        } else {
                            this.handleAddDataApi();
                        }

                    }
                })
            },
            handleAddDataApi() {
                addDictData(this.modelForm)
                .then(res => {
                    this.submitLoading = false;
                    let data = res.data;
                    if(data.code == 200) {
                        this.$refs.modelForm.clearValidate();
                        this.isShow = false;
                        this.$message.success(data.msg);
                        this.getAllDictList();
                    }
                })
            },
            handleEditDataApi() {
                editDictData(this.modelForm)
                .then(res => {
                    this.submitLoading = false;
                    let data = res.data;

                    if(data.code == 200) {
                        this.$refs.modelForm.clearValidate();
                        this.isShow = false;
                        this.$message.success(data.msg);
                        this.getAllDictList();

                    }
                })
            },
            handleAddDict() {
                this.isShow = true;
                this.modelForm = {
                    title: "",
                    value: "",
                    description: "",
                    dictId: this.parentId
                }
            },
            handleEditDict(row) {
                this.isShow = true;
                this.modelForm = _.cloneDeep(row);
            },
            handleDelDict(row) {
                
                this.$confirm("您确认要删除 " + row.title + " ?", '确认删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                     // 删除
                    deleteData(row.id).then(res => {
                        
                        let data = res.data;
                        if (data.code == 200) {
                            this.$message.success("操作成功");
                            this.getAllDictList();
                        }
                    });
                })
            },
            handleSearch(){
                this.searchForm.pageNumber = 1;

                this.getAllDictList();
            },
            handleReset(){
                this.searchForm = {
                    title: "",
                    status: "",
                    pageNumber: 1,
                    pageSize: 10,
                    sort: "sortOrder",
                    order: "asc",
                    dictId: this.parentId
                }
                this.getAllDictList();
            },
            handleChangePage(v){
                this.searchForm.pageNumber = v;
                this.getAllDictList();

            },
            handleChangePageSize(v){
                this.searchForm.pageSize = v;
                this.searchForm.pageNumber = 1;
                this.getAllDictList();
            },
            getAllDictList() {
                this.isLoading = true;
                getAllDictDataList(this.searchForm)
                .then(res => {
                    this.isLoading = false;
                    let data = res.data;
                    if(data.code == 200) {
                        this.dicList = data.data.records;
                        this.total = data.data.total;
                    }
                })
            }
        },
        created(){
            this.searchForm.dictId = this.parentId;
            this.getAllDictList();

        }
    }
</script>
